<script>
import SmallTaskSingle from './SmallTaskSingle.vue';
import SingleTaskFormNew from './SmallTaskFormNew.vue';
import { getAllSmallTasksFromDbase } from '@/services/SmallTasksServices';

export default {
  props: [ 'propSmallTasks' ],
  components: {
    SmallTaskSingle,
    SingleTaskFormNew,
  },
  data() {
    return {
      smallTasks: [],
    };
  },
  computed: {
    uId() { return this.$store.getters['uId']; },
    token() { return this.$store.getters['token']; },
    today() { return this.$store.getters['today']; },
    showFormToAddNewSmallTask() { return this.smallTasks.length < 20; },
    smallTasksCount() {
      let c = '';
      if (this.propSmallTasks.length) {
        c = ' (' + this.propSmallTasks.length + ')';
      }
      return c;
    }
  },
  methods: {
    async refreshSmallTasks() {
      // make an api call to refresh the smallTasks array in this component;
      this.smallTasks = await getAllSmallTasksFromDbase(this.uId, this.token, this.today);
    },
  },
  created() {
    this.smallTasks = this.propSmallTasks ? [ ...this.propSmallTasks ] : [];
  },
};
</script>

<template>
  <div class="my-12">
    <h3><u>Small Tasks for today {{smallTasksCount}}</u></h3>

    <v-card v-for="task in smallTasks"
            :key="task.id"
            class="d-flex flex-column" variant="flat"
    >
      <SmallTaskSingle :propTask="task" />
    </v-card>

    <div v-if="showFormToAddNewSmallTask" class="mb-3">
      <SingleTaskFormNew @addedNewSmallTask="refreshSmallTasks" />
    </div>

  </div>
</template>
